import React from 'react'
import { withRouter } from 'react-router-dom'
import { withAuthentication } from '../Session'
import { compose } from 'recompose'
import FormComponent from '../Form'
import { Container } from 'semantic-ui-react'
import mediaForm from './config/media-form'
import { AutoHeader } from '../Common'

class MediaCreatePage extends React.Component {
   render() {
      return (
         <Container>
            <AutoHeader />
            <Container>
               <FormComponent form={mediaForm} {...this.props} />
            </Container>
         </Container>
      )
   }
}

export default compose(withRouter, withAuthentication)(MediaCreatePage)
